interface State {
    name: string,
    code: string,
    subdivision: string
}

export const States:State[] = [
    {
		"name": "Wilayah Persekutuan Kuala Lumpur",
		"code": "MY-14",
		"subdivision": "federal territory"
	},
	{
		"name": "Wilayah Persekutuan Labuan",
		"code": "MY-15",
		"subdivision": "federal territory"
	},
	{
		"name": "Wilayah Persekutuan Putrajaya",
		"code": "MY-16",
		"subdivision": "federal territory"
	},
	{

        
		"name": "Johor",
		"code": "MY-01",
		"subdivision": "state"
	},
	{
		"name": "Kedah",
		"code": "MY-02",
		"subdivision": "state"
	},
	{
		"name": "Kelantan",
		"code": "MY-03",
		"subdivision": "state"
	},
	{
		"name": "Melaka",
		"code": "MY-04",
		"subdivision": "state"
	},
	{
		"name": "Negeri Sembilan",
		"code": "MY-05",
		"subdivision": "state"
	},
	{
		"name": "Pahang",
		"code": "MY-06",
		"subdivision": "state"
	},
	{
		"name": "Perak",
		"code": "MY-08",
		"subdivision": "state"
	},
	{
		"name": "Perlis",
		"code": "MY-09",
		"subdivision": "state"
	},
	{
		"name": "Pulau Pinang",
		"code": "MY-07",
		"subdivision": "state"
	},
	{
		"name": "Sabah",
		"code": "MY-12",
		"subdivision": "state"
	},
	{
		"name": "Sarawak",
		"code": "MY-13",
		"subdivision": "state"
	},
	{
		"name": "Selangor",
		"code": "MY-10",
		"subdivision": "state"
	},
	{
		"name": "Terengganu",
		"code": "MY-11",
		"subdivision": "state"
	}
]